import Fields from "./FillingCalculatorFields";
import Result from "./FillingCalculatorResult";
import Description from "./FillingCalculatorDescription";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const FillingCalculator = { Description, Fields, Result, Custom, calculate };

export default FillingCalculator;
